import { render, staticRenderFns } from "./CustomIcon.vue?vue&type=template&id=6cb349b7&scoped=true"
import script from "./CustomIcon.vue?vue&type=script&lang=js"
export * from "./CustomIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb349b7",
  null
  
)

export default component.exports